import { DELIVERY_METHODS_ROUTES } from './DeliveryMethods/shippingRoutes';
import { LOCATIONS_ROUTES } from './Locations/locationsRoutes';

export const SHIPPING_ROUTES = {
  ...DELIVERY_METHODS_ROUTES,
  ...LOCATIONS_ROUTES,
};
